<div class="row mb-5">
  <div class="col-md-8">
    <div class="font-weight-extrabold font-size-large text-black">
      {{ 'mysec.team' | translate }}
    </div>
  </div>
  <div class="col-md-4 text-right">
    <div class="btn btn-green" routerLink="team-member/add">
      + {{ 'mysec.addTeamMember' | translate }}
    </div>
  </div>
</div>
<div class="row">
  @if (!isLoading) {
    <div class="col-12">
      @for (teamMember of teams; track teamMember) {
        <div class="row border-bottom pb-5 mb-4">
          <div class="col-12 d-flex font-size-smaller">
            <div class="pr-3">
              <img class="profile-image" [src]="teamMember.imageUrl || defaultProfileImage" />
            </div>
            <div class="d-flex flex-column">
              <div class="font-weight-extrabold text-black name-col">{{ teamMember.name }}</div>
              <div class="mb-3 font-weight-bold name-col">{{ teamMember.position }}</div>
              <div [innerText]="teamMember.details"></div>
            </div>
            <div class="action-container">
              <div
                class="pitchin-icon pitchin-icon-edit-red mr-3"
                [routerLink]="['team-member', 'edit', teamMember.id]"
              ></div>
              <div
                class="pitchin-icon pitchin-icon-delete-red"
                (click)="delete(teamMember.id)"
              ></div>
            </div>
          </div>
        </div>
      }
    </div>
  }
  @if (!isLoading && (!teams || teams.length == 0)) {
    <div class="col-12 py-4 text-center">
      {{ 'common.noRecord' | translate }}
    </div>
  }
  @if (isLoading) {
    <div class="col-12">
      <agmo-loading></agmo-loading>
    </div>
  }
</div>
